import { render, staticRenderFns } from "./CurrentInvestment.vue?vue&type=template&id=85db10b2&scoped=true"
import script from "./CurrentInvestment.vue?vue&type=script&lang=js"
export * from "./CurrentInvestment.vue?vue&type=script&lang=js"
import style0 from "./CurrentInvestment.vue?vue&type=style&index=0&id=85db10b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85db10b2",
  null
  
)

export default component.exports